const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000/api/v1'

class AuthService {
  constructor() {
    this.token = localStorage.getItem('admin_token')
    this.isAuthenticated = !!this.token
  }

  async login(password) {
    try {
      const response = await fetch(`${API_BASE_URL}/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ password })
      })

      if (!response.ok) {
        const errorData = await response.json()
        throw new Error(errorData.detail || 'Erreur de connexion')
      }

      const data = await response.json()
      
      // Stocker le token
      this.token = data.access_token
      this.isAuthenticated = true
      localStorage.setItem('admin_token', this.token)
      
      return data
    } catch (error) {
      console.error('Erreur de connexion:', error)
      throw error
    }
  }

  async verifyToken() {
    if (!this.token) {
      return false
    }

    try {
      const response = await fetch(`${API_BASE_URL}/auth/verify`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${this.token}`,
          'Content-Type': 'application/json',
        }
      })

      if (!response.ok) {
        this.logout()
        return false
      }

      const data = await response.json()
      return data.valid && data.admin
    } catch (error) {
      console.error('Erreur de vérification du token:', error)
      this.logout()
      return false
    }
  }

  logout() {
    this.token = null
    this.isAuthenticated = false
    localStorage.removeItem('admin_token')
  }

  getAuthHeaders() {
    if (!this.token) {
      return {}
    }
    
    return {
      'Authorization': `Bearer ${this.token}`,
      'Content-Type': 'application/json',
    }
  }

  async makeAuthenticatedRequest(url, options = {}) {
    const headers = {
      ...this.getAuthHeaders(),
      ...options.headers
    }

    const response = await fetch(url, {
      ...options,
      headers
    })

    // Si le token est invalide, déconnecter l'utilisateur
    if (response.status === 401) {
      this.logout()
      throw new Error('Session expirée. Veuillez vous reconnecter.')
    }

    return response
  }
}

export const authService = new AuthService()
